module.exports = __webpack_public_path__ + "media/src/assets/noitems-0a0908534920c08a45a9785b604951bb.png";